import { useMutation } from "@tanstack/react-query";
import api from "apis";
import { DocumentTempSaveRequest } from "apis/data-contracts";

export interface UpdateDocumentTempParams {
  uuid: string;
  data: DocumentTempSaveRequest;
}

export const useUpldateTempDocumentMutation = () => {
  return useMutation({
    mutationFn: ({ uuid, data }: UpdateDocumentTempParams) =>
      api.document.updateDocumentTemp(uuid, data),
  });
};
